export enum WAMetaMessageDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}
